import AppLayout from '../../layouts/AppLayout';
import { useRecommendedCommunities } from '../../api-services/community/useRecommendedCommunities';
import community_api from '../../api-services/community/community.services';
import { Community } from '../../app-schemas/community/community.interface';
import { CommunityImage } from '../../assets/custom-icons';
import { tinyAlert, truncateText } from '../../app-utils';
import CommunityTopBar from './CommunityTopBar';

// main-component-ui
const MoreCommunity = () => {
  const recommendedCommunities = useRecommendedCommunities();

  // join a community
  const handleJoinCommunity = async (id: number) => {
    try {
      const res = await community_api.JoinCommunity(id);

      console.log(res);

      if (res?.data?.status) {
        tinyAlert('success', 'Success');
        recommendedCommunities.refetch();
      }
    } catch (error) {
      tinyAlert('error', 'An error occured!');
    } 
    // finally {
    //   console.log('dd');
    // }
  };


  return (
    <AppLayout title="Catapot - Community">
      <div className="bg-white pb-4 dark:bg-neutral-800">
        <CommunityTopBar/>
      </div>
      <section className={`bg-white dark:bg-neutral-800 shadow-sm min-h-screen pb-16`}>
        <div className='px-4 py-10 border-b'>
          <h2 className='text-center font-bold text-lg'>Explore Comunities</h2>
          <p className='text-center text-xs mt-2'>Are you looking to build a community around a shared interest, goal, or passion? Explore more  Communities</p>
        </div>
        {/* community area */}
        <div className=''>
          {recommendedCommunities.isLoading ? (
            /* UI for lazy loding */
            <div className="recommended-communities-lazy-loading-ui"></div>
          ) : (
            <>
              {!!recommendedCommunities?.data?.length &&
                recommendedCommunities?.data?.map((community: Community, index: number) => (
                  <div
                    key={index}
                    className="pl-3 pr-1 border-b last:border-b-0 bg-[#F3F9FE] dark:bg-neutral-800 gap-1 p-[1px] justify-between border-[#CED5DC] items-center flex bg-[#1976d21c]"
                  >
                    <div className="flex-grow flex py-4">
                      <div className="overflow-hidden flex justify-center">
                        <img
                          src={
                            !!community.cover_image_url ? community.cover_image_url : CommunityImage
                          }
                          alt="community icon"
                          className="object-cover rounded-[50px] w-[60px] h-[50px] shadow-sm overflow-hidden"
                        />
                      </div>

                      <div className="px-2 w-full">
                        <p className="overflow-hidden flex-col text-base font-medium m-0 flex gap-1 madimi-one text-black font-[400] dark:text-white">
                          {truncateText(community.name, 20)}
                        </p>
                        <div className="flex-col ">
                          <p className="text-gray-700 dark:text-white/80 font-[500] text-xs">{`${
                            community.members
                          } member${community.members > 1 ? 's' : ''}`}</p>
                        </div>
                      </div>
                    </div>

                    <div className="w-auto flex justify-center px-2">
                      <button
                        onClick={() => handleJoinCommunity(community.id)}
                        className="justify-center px-5 py-2 rounded-full w-auto h-auto shadow-sm flex font-semibold text-gray-200 bg-[#1976D2] text-xs gap-1"
                      >
                        {/* {icon && <LuPlus className="text-sm" />} */}
                        <span className="capitalize text-xs">JOIN</span>
                      </button>
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      </section>
    </AppLayout>
  );
};

export default MoreCommunity;
